import { DOMAIN } from "@/constants/env"

export const ACI_PAYMENT_CHECKOUT_ENDPOINT = "/payment/checkout"
export const ACI_PAYMENT_CHECKOUT_V1_ENDPOINT = "/payment/v1/checkout"
export const ORDER_SUBMIT_V3_ENDPOINT = "/checkout/v3/order/submit"
export const ORDER_SUBMIT_V2_ENDPOINT = "/checkout/v2/order/submit"
export const ACI_PAYMENT_CALLBACK_ENDPOINT = "/payment/checkout/callback"
export const ACI_PAYMENT_RESULT_MESSAGE_TYPE = "ACI_PAYMENT_RESULT"
export const ACI_PAYMENT_RESULT_URL = "/api/checkout/aci-payment-result"
export const CHANGE_PASSWORD_ENDPOINT = "/customer/change_password"
export const CATALOG_NOTIFY_ENDPOINT = "catalog/product/oos/notify"
export const CATALOG_PROJECTION_ENDPOINT = "/catalog/product/projection"
export const FEATURE_FLAGS_API_ENDPOINT = `${DOMAIN}/api/featureflags`
export const SVG_METADATA_ENDPOINT = "/catalog/svg/metadata"
export const ML_END_POINT = "https://api-kohler-int-test.azure-api.net"
export const ADOBE_TARGET_PRODUCT_RECOMMENDETION_ENDPOINT =
  "/catalog/product/recommendation"
export const USER_LIST_DELETE_END_POINT = "/shopping-list"
export const SEARCH_FULL_CATALOG = "/search/full-catalog"
export const CART_OFFER_ENDPOINT = "/cart/offer?discountCodeList=true"
export const SWATCH_ORDER_CATALOG = "/search/swatch"
export const THREEKIT_DATATABLE_END_POINT = "/catalog/product/configurator"
export const ORDER_LOGGING_ENDPOINT = `${DOMAIN}/api/order-logging`
export const PCIPAL_SESSION_ENDPOINT = "/payment/agent/session"
export const oktaTokenEndpoint = "/oauth/token"
export const validateTokenEndPoint = "/oauth/token/validate"
export const reviewStatsEndPoint = "/data/statistics.json"
export const reviewDataEndPoint = "/data/reviews.json"
export const FIND_MY_ORDERS_V1_ENDPOINT = "/checkout/orders/v1/query"
export const FIND_MY_ORDERS_ENDPOINT = "/checkout/orders/query"
export const PLP_END_POINT = "/apirequest/search/v1/plp"
export const PLP_END_POINT_CLIENT = "/search/v1/plp"
export const PLP_END_POINT_SUBSCRIPTION_KEY = "/lw/plp"
export const PDP_END_POINT_SUBSCRIPTION_KEY = "/lw/v1/pdp/product"
export const BUNDLE_PDP_END_POINT_SUBSCRIPTION_KEY = "/lw/pdp/"
export const PROFILE_END_POINT_CLIENT = "/search/v1/profile"
export const SEARCH_FEATURE_RESULTS_ENDPOINT = "/bin/kohler/searchpanelfragment"
export const GET_CITY_AND_STATE_BY_ZIPCODE = "/maps/v2/location/zipcode"
export const CORE_GLOBAL_CONFIG_URL = "/api/globalconfig"
export const ML_API_MODEL_1 = "/pia-qa/model1"
export const ML_API_MODEL_2 = "/pia-qa/model2"

export const EDIT_PROFILE_ENDPOINT = "/customer/profile"
export const DELETE_ACCOUNT_ENDPOINT = "/customer/account"
export const CHANGE_ACCOUNT_PASSWORD_ENDPOINT = "/customer/change_password"

// Backward compatible aliases.
export const searchFeatureResults = SEARCH_FEATURE_RESULTS_ENDPOINT
